import { FC } from "react";

import { RelatedCasesTable } from "src/components/case/RelatedCasesTable";
import Loading from "src/components/DataStates/Loading.tsx";
import { PassiveModal } from "src/components/Modal";
import { useGetBlacklistableIdentifiersRelatedCasesQuery } from "src/graphql/anti-fraud/queries/cases/GetCaseBlacklistableIdentifiersRelatedCasesQuery";
import { useT } from "src/internationalization";

export type RelatedCasesModalProps = {
  onClose: () => void;
  caseId: string;
  identifierId: string;
};

// TODO make it wide
export const RelatedCasesModal: FC<RelatedCasesModalProps> = ({
  onClose,
  caseId,
  identifierId,
}) => {
  const t = useT();

  const { data, loading, error } = useGetBlacklistableIdentifiersRelatedCasesQuery({
    variables: {
      id: caseId,
      includeLinkedCaseIdentifiers: true,
    },
    fetchPolicy: "cache-first",
  });

  const cases = data[identifierId] ?? [];

  return (
    <PassiveModal
      onClose={onClose}
      size="xl"
      title={t("cases.relatedCases.modal.title", {
        number: loading ? "" : cases.length ?? "",
      })}
      fullHeight
    >
      <div className="full-height">
        {loading ? (
          <Loading />
        ) : (
          <RelatedCasesTable cases={cases} loading={false} isError={!!error} />
        )}
      </div>
    </PassiveModal>
  );
};
